import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Calendar() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/schedule").then((r) => setEvents(r.data)); }, []);
  const sorted = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
  return (
    <div data-testid="calendar-page">
      <div className="eyebrow mb-1">Calendar</div>
      <h1 className="font-display text-2xl sm:text-3xl uppercase mb-5">All Events</h1>
      <div className="space-y-3">
        {sorted.length === 0 && (
          <div className="kr-card rounded-xl p-8 text-center text-slate-500 text-sm">
            No events scheduled yet.
          </div>
        )}
        {sorted.map((e) => {
          const d = new Date(e.date);
          return (
            <div key={e.id} className="kr-card rounded-xl p-3 sm:p-4 flex items-center gap-3 sm:gap-4">
              <div className="text-center w-12 sm:w-14 shrink-0">
                <div className="font-display text-xl sm:text-2xl text-[#00E5FF]">{d.getDate()}</div>
                <div className="text-[10px] uppercase text-slate-400">{d.toLocaleString('en-US', { month: 'short' })}</div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold truncate">{e.title}</div>
                <div className="text-xs text-slate-400 truncate">{e.location}{e.opponent && ` · vs ${e.opponent}`}</div>
              </div>
              <span className="text-[10px] uppercase tracking-widest text-slate-400 border border-white/10 rounded-full px-2 sm:px-3 py-1 shrink-0">{e.type}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
